import { executeRequest, Request } from '@jfs/network'
import { getUpdateUserBody } from './../data/request/requestbody'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const updateUser = (appUser: any, tokens: any, userAccessToken: string) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.UpdateUser,
    method: 'PUT',
    config: sitConfig(tokens),
    body: getUpdateUserBody(appUser),
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { updateUser }
